@if (!commissionNumber && vin) {
  <div id="vehicle-navigation" class="container">
    <mat-card class="m-auto rounded-lg my-14">
      <nav
        mat-tab-nav-bar
        [tabPanel]="tabPanel"
        mat-stretch-tabs
        class="w-[calc(100%+32px)] -mx-4 md:w-full md:mx-auto lg:w-10/12 ef-tab-nav-bar"
        >
        @for (i of navigationItems; track i) {
          @if (!i.hidden) {
            <a
              data-cy="vehicle-navigation-tab"
              mat-tab-link
              (click)="sendContentModulesTabSwitchData(i)"
              [routerLink]="i.pathWithParams"
              [routerLinkActive]="['active']"
              class="relative gap-1 min-w-fit"
              #rla="routerLinkActive"
              [active]="rla.isActive"
              >
              <T
              [str]="i.name"
              [key]="i.translationKey"
              tags="customer-portal, notranslate"
            ></T>
            @if (i?.unreadDocuments) {
              <span
                class="ml-1 flex justify-center items-center bg-mat-ef-revolution-secondary-500 rounded-full text-xs h-5 w-5 text-white"
                >{{ i?.unreadDocuments }}</span
                >
              }
            </a>
          }
        }
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
      @if (showVehicleDetails) {
        <customer-portal-app-revolution-vehicle-details-view
          >
        </customer-portal-app-revolution-vehicle-details-view>
      }
    </mat-card>
  </div>
}

@if (commissionNumber) {
  <customer-portal-app-vehicle-track-trace
  ></customer-portal-app-vehicle-track-trace>
}
